export class ClearPlacementsLoadingStatus {
    public static readonly type = '[JobsPlacements] Clear placements loading status';
}
